import axios from 'axios'
import Cookies from 'js-cookie'

/**
 * Centralized axios instance with CSRF token for Django API requests.
 */
export const api = axios.create({
    headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
    },
    withCredentials: true,
})
